((homepageOurStory, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homepageOurStory = $('.home-our-story__sliders-container');
  };

  const bindUIActions = () => {

    $dom.homepageOurStory.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 768,
          settings: {}
        }
      ]
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepageOurStory.init = init;

})(window.homepageOurStory = window.homepageOurStory || {}, jQuery);
